/**
 * @thesitebook/contracts
 *
 * Shared Zod schemas + DTOs for The Site Book web <-> mobile (v3.0).
 *
 * This package is the single source of truth for the `/api/mobile/v1/*` wire
 * format. Phase 03 populates it with entity schemas (projects, documents,
 * workers, subs, COSHH, diary, incidents, permits, signatures, uploads, AI).
 *
 * Rules (preserved across phases):
 *   - No imports of Next.js, Prisma client, Clerk server SDK, or any
 *     browser/node-only API. Pure TypeScript + Zod only.
 *   - All exports MUST be tree-shakeable.
 *   - Bump CONTRACTS_VERSION when the wire format makes a breaking change.
 */

export * from "./version";
export * from "./errors";
export * from "./common";
export * from "./pagination";
export * from "./auth";
export * from "./entities";
export * from "./wizard-schemas";
export * from "./wizard-config";
export * from "./analytics";
export * from "./in-app-approval";
export * from "./document-approval";

export * from "./mobile-replay";
export * from "./generation-input";
export * from "./generation-project-review";
export * from "./rams";

export * from "./mobile-safety-writes";
export * from "./project-induction-limits";
